import { detectUserAgent } from 'utils';

import { ChainType } from 'types';

export enum Environment {
  Production = 'Production',
  Staging = 'Staging',
}

export const isDevelopment = process.env.NODE_ENV === 'development';
export const env: Environment = Environment.Production;
export const ecosystem = process.env.REACT_APP_ECOSYSTEM?.toLocaleLowerCase();
export const apiUrl = process.env.REACT_APP_API_URL || '';
export const zeroContract = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const walletConnectKey = process.env.REACT_APP_WALLET_CONNECT_KEY;

const permanentConfig = {
  siteName: 'Cables',
  ecosystem: ecosystem === ChainType.Mainnet ? ChainType.Mainnet : ChainType.Testnet,
  userAgent: detectUserAgent(),
};
export interface PermanentConfigI {
  siteName: string;
  environment: Environment;
  wsUrl: string;
  cablesUrl: string;
  cablesGqlUrl: string;
  ecosystem: ChainType;
  userAgent: string;
}

export interface ConfigEnvI extends PermanentConfigI {
  Production: PermanentConfigI;
  Staging: PermanentConfigI;
}

// @ts-ignore
const envs: ConfigEnvI = {
  Production: {
    ...permanentConfig,
    environment: Environment.Production,
    wsUrl: `wss://${apiUrl}/graphql`,
    cablesUrl: `https://${apiUrl}`,
    cablesGqlUrl: `https://${apiUrl}/graphql`,
  },
  Staging: {
    ...permanentConfig,
    environment: Environment.Staging,
    wsUrl: `wss://${apiUrl}/graphql`,
    cablesUrl: `https://${apiUrl}`,
    cablesGqlUrl: `https://${apiUrl}/graphql`,
  },
};

export default envs[env] as ConfigEnvI;
